var _circle, _polygon, _path, _polygon2, _circle2, _polygon3, _path2, _polygon4, _path3, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeadership(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 15,
    r: 5,
    fill: "#1895aa"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1895aa",
    points: "36 32 32 38 28 42 31 45 36 40 41 33 36 32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1895aa",
    d: "M53,24V20H37l-9,8,2,3,3.9-2.94a4,4,0,0,0,3.37,5.42L43,34v6h5V31.69a2,2,0,0,0-1.67-2L42,29l1-5Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e05b69",
    points: "53 2 53 12 62 7 53 2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 25,
    r: 5,
    fill: "#f7d04f"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7d04f",
    points: "11 42 7 48 3 52 6 55 11 50 16 43 11 42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7d04f",
    d: "M21.33,39.72,17,39l1-4h5l7-4-2-3-6,3-6-1H12L8.9,38.06a4,4,0,0,0,3.37,5.42L18,44v6h5V41.69A2,2,0,0,0,21.33,39.72Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ef9f35",
    points: "2 62 2 61 16 58 16 50 32 50 41 40 62 40 62 62 2 62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f6ed",
    d: "M17,4a6,6,0,0,0-1.5.2A8,8,0,0,0,2,10v1H23V10A6,6,0,0,0,17,4Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 17,
    y: 13,
    fill: "#f9f6ed"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 21,
    y: 13,
    fill: "#f9f6ed"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 25,
    y: 13,
    fill: "#f9f6ed"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 29,
    x: 52,
    y: 2,
    fill: "#5a5a60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadership);
export default __webpack_public_path__ + "static/media/leadership.8f5c21da62b46e0babd6323115ac7953.svg";
export { ForwardRef as ReactComponent };